import React from 'react';
import { Card, Row, Col, Typography, Avatar } from 'antd';
import millify from 'millify';

const { Title, Text } = Typography;

const mockCryptocurrencies = [
    { id: 1, name: 'Bitcoin', symbol: 'BTC', price: 45000, marketCap: 850000000000, logoUrl: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png' },
    { id: 2, name: 'Ethereum', symbol: 'ETH', price: 3000, marketCap: 350000000000, logoUrl: 'https://cryptologos.cc/logos/ethereum-eth-logo.png' },
    { id: 3, name: 'Ripple', symbol: 'XRP', price: 1.2, marketCap: 60000000000, logoUrl: 'https://cryptologos.cc/logos/ripple-xrp-logo.png' },
    { id: 4, name: 'Litecoin', symbol: 'LTC', price: 150, marketCap: 10000000000, logoUrl: 'https://cryptologos.cc/logos/litecoin-ltc-logo.png' },
    { id: 5, name: 'Cardano', symbol: 'ADA', price: 1.5, marketCap: 50000000000, logoUrl: 'https://cryptologos.cc/logos/cardano-ada-logo.png' },
    { id: 6, name: 'Polkadot', symbol: 'DOT', price: 20, marketCap: 20000000000, logoUrl: 'https://cryptologos.cc/logos/polkadot-dot-logo.png' },
    { id: 7, name: 'Chainlink', symbol: 'LINK', price: 25, marketCap: 11000000000, logoUrl: 'https://cryptologos.cc/logos/chainlink-link-logo.png' },
    { id: 8, name: 'Binance Coin', symbol: 'BNB', price: 400, marketCap: 60000000000, logoUrl: 'https://cryptologos.cc/logos/binance-coin-bnb-logo.png' },
    { id: 9, name: 'Dogecoin', symbol: 'DOGE', price: 0.25, marketCap: 32000000000, logoUrl: 'https://cryptologos.cc/logos/dogecoin-doge-logo.png' },
    { id: 10, name: 'Solana', symbol: 'SOL', price: 100, marketCap: 30000000000, logoUrl: 'https://cryptologos.cc/logos/solana-sol-logo.png' },
    { id: 11, name: 'Avalanche', symbol: 'AVAX', price: 70, marketCap: 15000000000, logoUrl: 'https://cryptologos.cc/logos/avalanche-avax-logo.png' },
    { id: 12, name: 'Shiba Inu', symbol: 'SHIB', price: 0.00002, marketCap: 20000000000, logoUrl: 'https://cryptologos.cc/logos/shiba-inu-shib-logo.png' },
    { id: 13, name: 'Polygon', symbol: 'MATIC', price: 1.5, marketCap: 12000000000, logoUrl: 'https://cryptologos.cc/logos/polygon-matic-logo.png' },
    { id: 14, name: 'Uniswap', symbol: 'UNI', price: 25, marketCap: 15000000000, logoUrl: 'https://cryptologos.cc/logos/uniswap-uni-logo.png' },
    { id: 15, name: 'Terra', symbol: 'LUNA', price: 80, marketCap: 20000000000, logoUrl: 'https://cryptologos.cc/logos/terra-luna-logo.png' },
    { id: 16, name: 'Algorand', symbol: 'ALGO', price: 1.2, marketCap: 8000000000, logoUrl: 'https://cryptologos.cc/logos/algorand-algo-logo.png' },
    { id: 17, name: 'Cosmos', symbol: 'ATOM', price: 30, marketCap: 7000000000, logoUrl: 'https://cryptologos.cc/logos/cosmos-atom-logo.png' },
    { id: 18, name: 'NEO', symbol: 'NEO', price: 20, marketCap: 3000000000, logoUrl: 'https://cryptologos.cc/logos/neo-neo-logo.png' },
    { id: 19, name: 'Zilliqa', symbol: 'ZIL', price: 0.1, marketCap: 1200000000, logoUrl: 'https://cryptologos.cc/logos/zilliqa-zil-logo.png' },
    { id: 20, name: 'Bitcoin Cash', symbol: 'BCH', price: 500, marketCap: 10000000000, logoUrl: 'https://cryptologos.cc/logos/bitcoin-cash-bch-logo.png' },
    { id: 21, name: 'Stellar', symbol: 'XLM', price: 0.4, marketCap: 9000000000, logoUrl: 'https://cryptologos.cc/logos/stellar-xlm-logo.png' },
    { id: 22, name: 'Tether', symbol: 'USDT', price: 1, marketCap: 70000000000, logoUrl: 'https://cryptologos.cc/logos/tether-usdt-logo.png' },
    { id: 23, name: 'Tron', symbol: 'TRX', price: 0.08, marketCap: 8000000000, logoUrl: 'https://cryptologos.cc/logos/tron-trx-logo.png' },
    { id: 24, name: 'Monero', symbol: 'XMR', price: 250, marketCap: 4500000000, logoUrl: 'https://cryptologos.cc/logos/monero-xmr-logo.png' },
    { id: 25, name: 'Dash', symbol: 'DASH', price: 150, marketCap: 1500000000, logoUrl: 'https://cryptologos.cc/logos/dash-dash-logo.png' },
    { id: 26, name: 'Zcash', symbol: 'ZEC', price: 120, marketCap: 1200000000, logoUrl: 'https://cryptologos.cc/logos/zcash-zec-logo.png' },
    { id: 27, name: 'Decred', symbol: 'DCR', price: 80, marketCap: 1000000000, logoUrl: 'https://cryptologos.cc/logos/decred-dcr-logo.png' },
    { id: 28, name: 'Siacoin', symbol: 'SC', price: 0.01, marketCap: 500000000, logoUrl: 'https://cryptologos.cc/logos/siacoin-sc-logo.png' },
    { id: 29, name: 'Lisk', symbol: 'LSK', price: 5, marketCap: 600000000, logoUrl: 'https://cryptologos.cc/logos/lisk-lsk-logo.png' },
    { id: 30, name: 'Waves', symbol: 'WAVES', price: 15, marketCap: 1500000000, logoUrl: 'https://cryptologos.cc/logos/waves-waves-logo.png' },
];

const Exchanges = () => {
    return (
        <div style={{ padding: '20px', backgroundColor: '#121212' }}>
            <Title level={2} style={{ color: '#FF5722' }}>Top 30 Cryptocurrencies</Title>
            <Row gutter={[16, 16]}>
                {mockCryptocurrencies.map((crypto) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={crypto.id}>
                        <Card
                            hoverable
                            style={{
                                textAlign: 'center',
                                backgroundColor: '#1E1E1E',
                                color: 'white',
                                borderRadius: '12px',
                                border: '1px solid #FF5722',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                                transition: 'all 0.3s ease-in-out',
                            }}
                            bodyStyle={{ padding: '16px' }}
                        >
                            <a href={`https://www.google.com/finance?q=${crypto.symbol}`} target="_blank" rel="noreferrer">
                                <Avatar
                                    src={crypto.logoUrl}
                                    size={64}
                                    style={{
                                        backgroundColor: '#FF5722',
                                        border: '2px solid white',
                                    }}
                                />
                                <Title level={4} style={{ color: 'white', margin: '10px 0' }}>
                                    {crypto.name} ({crypto.symbol})
                                </Title>
                                <Text style={{ color: '#FF5722', display: 'block' }}>
                                    Price: ${millify(crypto.price)}
                                </Text>
                                <Text style={{ color: '#FF5722' }}>
                                    Market Cap: ${millify(crypto.marketCap)}
                                </Text>
                            </a>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default Exchanges;
